<template>
  <div>
    <QueryForm
      @on-query="onQuery"
      @on-insert="onInsert"
    />
    <List
      :data="list"
      @on-detail="onItemDetail"
      @on-edit="onItemEdit"
      @on-delete="onItemDelete"
      :change="onChangePage"
      :total="total"
      :page-size="queryData.pageSize"
      :current="queryData.page"
    />
    <DetailModal
      v-model="detailModal"
      :data="detailData"
      ref="detailModalRef"
    />
    <EditModal
      v-model="editModal"
      ref="editModalRef"
      @on-save="onEditSave"
    />
  </div>
</template>

<script>
import List from './components/list'
import DetailModal from './components/detailModal'
import EditModal from './components/editModal'
import QueryForm from './components/queryForm'

export default {
  name: 'SupplierAccount',
  components: {
    List,DetailModal,EditModal,QueryForm
  },
  data () {
    return {
      list: [],
      editModal: false,
      detailData: {},
      detailModal: false,
      queryData: {
        page: 1,
        pageSize: 20
      },
      total: 0
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onQuery (queryData) {
      this.queryData={
        ...this.queryData,
        ...queryData,
        page: 1
      }
      this.loadData()
    },
    onInsert () {
      this.$refs['editModalRef'].setData({})
      this.editModal=true
    },
    onItemDetail (p) {
      this.detailData=p.row
      this.detailModal=true
    },
    onItemEdit (p) {
      this.$refs['editModalRef'].setData(Object.assign({},p.row))
      this.editModal=true
    },
    onItemDelete (p) {
      this.$Modal.confirm({
        title: '删除提示',
        content: '<p>确定要进行删除操作吗?</p>',
        onOk: () => {
          this.httpDeleteById(p.row.id)
        }
      });
    },
    onChangePage (page) {
      this.queryData.page=page
      this.loadData()
    },
    onEditSave (data) {
      this.$fetch('CusFahuo/save',data,'POST')
        .then(res => {
          this.$Message.success('保存成功')
          this.loadData()
          this.editModal=false
        })
    },
    loadData () {
      this.$fetch('CusFahuo/getList',this.queryData).then(res => {
        this.list=res.data.list
        this.total=res.data.total
      })
    },
    httpDeleteById (id) {
      this.$fetch('CusFahuo/del',{id}).then(res => {
        this.$Message.success('删除成功')
        this.loadData()
      })
    }
  }

}
</script>

<style>
</style>